<!--Scroll to top-->
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
	<button class="vl-button vl-button--tertiary vl-button--icon" (click)="scrollToTop()">
		<i class="vl-button__icon vl-vi vl-vi-nav-up-light" aria-hidden="true"></i>
		<span class="vl-u-hidden"></span>
	</button>
</div>
